import { Box } from '@mui/material'
import { FC, useState } from 'react'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

interface MasterStatusCellProps {
  params: GridRenderCellParams
  onClick: (params: GridRenderCellParams) => void
}

const MasterStatusCell: FC<MasterStatusCellProps> = ({ params, onClick }) => {
  const [_masterStatus, _setMasterStatus] = useState<string>(params?.value ?? 'Not Started')
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        cursor: !params?.row?.SK?.startsWith('PRODUCT_') ? 'pointer' : 'default',
        bgcolor: renderColorByString(params?.value),
      }}
      onClick={() => onClick(params)}
    >
      <Box
        sx={{
          bgcolor: renderColorByString(params?.value),
          textAlign: 'center',
          fontWeight: 'bold',
          width: '100%',
          height: '100%',
        }}
      >
        {/* {params?.value || 'Not Started'} */}
        {params?.value}
      </Box>
    </Box>
  )
}
export default MasterStatusCell
